(function($){
    var running = false,
        loading = false,
        offset = 0,
        FORM = '',
        category = '',
        pageNumber = 2,
        postPerPage = 10,
        noLoad = false,
        spinner = '.event-gallery__loader',
        overlay = '.event-gallery__overlay',
        toTop = '#toTop',
        clearFilter = '#clearFilter',
        param = '',
        startUrl = null;

    if (!running) {
        startUrl = document.location.href;
    }

    param = getUrlParameter('filter_seasons');

    if (param) {
        window.history.pushState({}, document.title, '/' + 'event-gallery/');

        category = param;
        noLoad = false;

        $('button[value="'+param+'"]').addClass('category-active');

        $(overlay).addClass('is-active');
        $(spinner).addClass('is-active');

        filter_article_posts();

        param = '';
    }

    if ($('.event-gallery').length) {
        $(window).scroll(function(e){
            var winScroll = $(this).scrollTop();
            var elePosition = $('.event-gallery').offset().top;
            var eleHeight = $('.event-gallery').outerHeight();
            var dif = 100;
            var total = eleHeight + elePosition + dif;

            if (winScroll + $(window).height() > total) {
                if (! loading && ! noLoad) {
                    append_articles();
                    $(overlay).addClass('is-active');
                    $(spinner).addClass('is-active');
                }
            }

            var _container = $('.site-main'),
                _offset = _container.offset(),
                _top = _offset.top,
                _bottom = ($(window).outerHeight() - _container.outerHeight()),
                _element = $('.block--jump-links');

            $('.site-main #content').css({
                'padding-bottom': _element.outerHeight()
            });
            
            if ( (winScroll + _bottom - _element.outerHeight() + _top + 50) > 0 ) {
                _element.addClass('position-bottom');
            } else {
                _element.removeClass('position-bottom');
            }
        });

    }

    $(document).on('click', function(e){
        var $this = $(e.target);

        if( !$this.parents('.block--jump-links').length ) {
            $('.mobile-visible').removeClass('mobile-visible');
        }
    });

    $('#mobileFilters').on('click touch', function(e){
        e.preventDefault();

        $(this).parents('.block--jump-links').toggleClass('mobile-visible');
    });

    $('button[name="gallery-category"]').on('click touch', function(e){
        e.preventDefault();

        running = false;

        FORM = $('.jump-links__form').serialize();
        category = $(this).val();

        noLoad = false;

        $('button.category-active').removeClass('category-active');
        $(this).addClass('category-active');

        $(overlay).addClass('is-active');
        $(spinner).addClass('is-active');

        filter_article_posts();
    });

    $(clearFilter).on('click touch', function(e){
        e.preventDefault();

        running = false;

        FORM = '';
        category = '';
        
        noLoad = false;

        $('button.category-active').removeClass('category-active');

        $(overlay).addClass('is-active');
        $(spinner).addClass('is-active');

        $(clearFilter).removeClass('is-visible');

        reset_article_posts();
    });

    $(toTop).on('click touch', function(e){
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $("#main").offset().top
        }, 1000);
    });

    function reset_article_posts()
    {
        var data = {
            action: 'event_gallery_ajax',
            page_number: 1,
            posts_per_page: 15,
            filter_seasons: category,
            query: cav_ajax.query
        };

        run_ajax( data, false, true );
    }
    
    function filter_article_posts()
    {
        var data = {
            action: 'event_gallery_ajax',
            page_number: 1,
            posts_per_page: 15,
            filter_seasons: category,
            query: cav_ajax.query
        };

        run_ajax( data, false, false );
    }

    function append_articles()
    {
        offset = $('.event-gallery__item').length;

        var data = {
            action: 'event_gallery_ajax',
            page_number: pageNumber,
            posts_per_page: postPerPage,
            filter_seasons: category,
            offset: offset,
            query: cav_ajax.query,
        };

        run_ajax( data );
    }

    function run_ajax( data, append = true, reset = false )
    {
        loading = true;

        let lastGal = $('.event-gallery__item:last');
        let curOffset = lastGal.offset().top - $(document).scrollTop();

        $.post(cav_ajax.ajaxurl, data, function(response){

            if (response.length) {
                if (append && !reset) {
                    $('#postList').append(response);
                } else {
                    $('#postList').html(response);

                    if (reset) {
                        $(clearFilter).removeClass('is-visible');
                    } else {
                        $(clearFilter).addClass('is-visible');
                    }
                }
    
                noLoad = true;

                pageNumber++;
            } else {
                noLoad = true;
            }

            $(overlay).removeClass('is-active');
            $(spinner).removeClass('is-active');

            loading = false;
        }).then(function(res){
        
            $(document).scrollTop(lastGal.offset().top - curOffset);    

            setTimeout(function(){
                if (res.length && noLoad) {
                    noLoad = false;
                }
            }, 1000);

        }).fail(function(xhr, textStatus, e){

            $(overlay).removeClass('is-active');
            $(spinner).removeClass('is-active');

            console.log(xhr);
            loading = false;
        });


        if( $('.event-gallery__item').length > 15 ) {
            $(toTop).addClass('is-visible');
        } else {
            $(toTop).removeClass('is-visible');
        }

        return false;
    }

    function getUrlParameter( sParam )
    {
        var sPageUrl = window.location.search.substring(1),
            sURLVariables = sPageUrl.split('&'),
            sParameterName,
            i;

        for ( i = 0; i < sURLVariables.length; i++ ) {
            sParameterName = sURLVariables[i].split('=');

            if( sParameterName[0] === sParam ) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }

        return false;
    }

})(jQuery);
